// Lightweight indirection so `userSessionStore` — imported almost everywhere —
// can trigger the app-state logout teardown without statically importing the
// heavy `appEffects` module graph (transport, flow stores, datadog, the color
// palette bridge, ...). `startAppEffects` registers the real teardown at
// runtime; before it runs (SSR, or a route that never mounts the bootstrap) the
// trigger is a no-op.

let teardown: (() => void) | null = null;

export function registerAppLogoutTeardown(fn: () => void): void {
    teardown = fn;
}

export function runAppLogoutTeardown(): void {
    teardown?.();
}
